import {Stack} from '@mui/material';
import styled from 'styled-components';

const Container = styled(Stack)`
	background-color: ${({theme}) => theme.palette.background.paper};

	display: flex;
	justify-content: space-between;

	padding: 16px;
	margin: 24px auto;
	border-radius: 8px;

	height: 100%;
	width: calc(100% - 64px);
	${({theme}) => theme.breakpoints.down('sm')} {
		width: calc(100% - 32px);
		margin: 16px auto;
	}
`;

const SelectWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

const SearchButton = styled.button`
	width: 36px;
	height: 36px;
	min-height: 36px;
	min-width: 36px;
	border: none;
	border-radius: 50%;
	align-self: flex-end;

	display: flex;
	align-items: center;
	justify-content: center;
	background-color: ${({theme}) => theme.colors.light.success.light};
	color: ${({theme}) => theme.colors.light.primary.main};

	:disabled {
		background-color: ${({theme}) => theme.colors.light.action.disabledBackground};
		color: rgba(0, 0, 0, 0.26);
		cursor: not-allowed;
	}
`;

const MobileSearchButton = styled.button`
	border: none;
	height: 36px;
	border-radius: 29px;
	padding: 4px 8px;
	text-align: center;
	flex: 1;

	background-color: ${({theme}) => theme.colors.light.success.light};
	color: ${({theme}) => theme.colors.light.primary.contrast};

	:disabled {
		background-color: ${({theme}) => theme.colors.light.action.disabledBackground};
		color: rgba(0, 0, 0, 0.26);
		cursor: not-allowed;
	}
`;

export {Container, MobileSearchButton, SearchButton, SelectWrapper};
